<section class="w-full  ">
    <!-- @if(view.site) {
        <div class="w-full relative h-[400px] bg-cover border-b-4 border-primary-500 bg-no-repeat bg-center flex flex-col justify-center items-center" [ngStyle]="{ 'background-image': 'url(' + view.imageHref + ')' }">
            <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
            <h1 class="z-10 custom_font text-6xl text-white text-shadow">{{view.page?.content.name}}</h1>
            <p class="z-10 text-xl text-white font-semibold"><span class="text-emerald-500 font-semibold">Home</span> / About</p>
        </div>
    } -->

    <div class="w-full p-6 relative h-[400px] bg-cover  bg-no-repeat bg-center flex flex-col justify-center "  style="background-image: url('https://bahiashipping.ph/assets/12-Pf5ndnpz.png');">
        <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
        <!-- <h1 class="z-10  text-7xl text-left text-white text-shadow font-extrabold uppercase "> {{view.page?.content.name}} </h1> -->
        <h1 class="z-10  text-7xl text-left text-white text-shadow font-extrabold uppercase border-b-2 border-primary-700 max-w-128"> About Whitestar </h1>
        <!-- <span class="w-60 border-b-4 border-primary-700 "></span> -->
        <p class="z-10 text-xl text-white font-light pt-2">
            Cruise Specialists Since 2004
        </p>
    </div>
    <div class="w-full flex flex-col items-center bg-white" id="about">
        <div class="w-full flex flex-col p-8 max-w-[800px] text-center -mt-16 absolute bg-white">
            <div class="w-full p-6  text-center  ring-2 ring-primary ">

                <h1 class="text-accent-500 text-center  font-light  text-4xl  w-[100%] mx-auto">
                    Whitestar Cruise & Travel is Your Premier Cruise Operator in Southern Africa!
                </h1>
                <p class="text-gray-500 text-center font-light font-bold pt-4 pb-4 w-[100%]  mx-auto">
                    As a highly focused cruise operator, we proudly represent a handpicked selection of premier cruise lines, including Cunard, P&O Cruises, Seabourn, Celestyal Cruises, NCL and VIVA.
                </p>
            </div>
        </div>
        <div class="h-60"></div>
        <div class="w-full flex justify-center m-auto ">
            <div class="w-full flex justify-center">
                <div class="flex items-center h-26 max-w-lg  justify-center"> <!-- Added justify-center to center horizontally -->
                    <div class="inline-flex flex-nowrap overflow-hidden items-center [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
                        <ul class="flex items-center justify-center  [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll">
                            <li>
                                <img class="w-20" src="https://whitestar.co.za/wp-content/uploads/2019/09/logo-cunard-1.svg" alt="" />
                            </li>
                            <li>
                                <img class="w-20" src="https://whitestar.co.za/wp-content/uploads/2019/09/logo-po-cruises.svg" alt="" />
                            </li>
                            <li>
                                <img class="w-20" src="https://whitestar.co.za/wp-content/uploads/2019/09/Celestyal-Logo.svg" alt="" />
                            </li>
                            <li>
                                <img class="w-20" src="https://whitestar.co.za/wp-content/uploads/2019/09/logo-seabourn.svg" alt="" />
                            </li>
                            <li>
                                <img class="w-20" src="https://whitestar.co.za/wp-content/uploads/2023/08/ncl-logo.svg" alt="" />
                            </li>
                            <li>
                                <img class="w-20" src="https://whitestar.co.za/wp-content/uploads/2023/04/viva-cruises-1.svg" alt="" />
                            </li>
                        </ul>
                        <ul class="flex items-center justify-center [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll">
                            <li>
                                <img class="w-20" src="https://whitestar.co.za/wp-content/uploads/2019/09/logo-cunard-1.svg" alt="" />
                            </li>
                            <li>
                                <img class="w-20" src="https://whitestar.co.za/wp-content/uploads/2019/09/logo-po-cruises.svg" alt="" />
                            </li>
                            <li>
                                <img class="w-20" src="https://whitestar.co.za/wp-content/uploads/2019/09/Celestyal-Logo.svg" alt="" />
                            </li>
                            <li>
                                <img class="w-20" src="https://whitestar.co.za/wp-content/uploads/2019/09/logo-seabourn.svg" alt="" />
                            </li>
                            <li>
                                <img class="w-20" src="https://whitestar.co.za/wp-content/uploads/2023/08/ncl-logo.svg" alt="" />
                            </li>
                            <li>
                                <img class="w-20" src="https://whitestar.co.za/wp-content/uploads/2023/04/viva-cruises-1.svg" alt="" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full mx-auto sm:px-6 pt-8 pb-16 grid md:grid-cols-2 lg:grid-cols-2 gap-y-8 lg:gap-x-8 lg:gap-y-16">
            <fuse-card class="flex flex-col w-full mx-auto overflow-hidden shadow-2xl hover:shadow-lg dark:border-0 dark:border-gray-500 dark:bg-gray-600">
                <div class="flex items-center justify-center bg-cover bg-center bg-no-repeat h-full" style="background-image: url('https://bahiashipping.ph/assets/12-Pf5ndnpz.png');">
                    <div class="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/40"></div>
                    <div class=" z-10 text-white px-4 py-4 text-xl tracking-wider text-shadow">
                        @if(view.site?.logoUrl) {
                            <img [alt]="view.site?.name" [src]="view.site?.logoUrl" style="max-width: 150px;" class="mx-auto ">
                        }
                    </div>
                </div>
            </fuse-card>
            <div  class="p-4">
                <h1 class="text-accent-500   font-light  text-4xl">We bring the best of the cruising world to your doorstep.</h1>
                <p class="px-2  text-justify text-gray-500 font-light py-2" >Established in 2004 under the guidance of Carol McCarthy and now run by Shaun McCarthy, Whitestar Cruise & Travel is based in Johannesburg, South Africa. With a wealth of experience and expertise, our dedicated team of cruise professionals is here to make your dream cruise a reality.</p>
                <p class=" px-2 text-justify text-gray-500 font-light py-2" >We are a boutique, independent business, and our strong partnerships with the international cruise companies we represent ensure you receive unparalleled support and benefits – we prioritise personalised service and attention to detail. </p>
                <p class="px-2  text-justify text-gray-500 font-light py-2" >Let us create your perfect cruising holiday that suits your unique travel needs and desires. </p>
                <p class="px-2  text-justify text-gray-500 font-light py-2 mb-4" >Are you ready to plan your next unforgettable holiday? Contact Whitestar Cruise & Travel today, and let us take you on a remarkable cruise adventure. Your dream voyage awaits!</p>
                <a routerLink="branches" class="mt-3 rounded font-light text-white py-3 px-6 transition bg-primary-500 hover:bg-accent-700 uppercase text-center"> contact us</a>
            </div>
        </div>
    </div>
    <div class="w-full flex flex-col py-10 bg-white">
    </div>
    <app-footer-type03></app-footer-type03>

</section>